import '../styles/main'
// import _ from 'lodash';
//import styles from './app.module'
// import 'bootstrap';


import { praxisgemeinschaft } from './praxisgemeinschaft.js'
praxisgemeinschaft.load();